export const brandNames = {
  vw: 'Volkswagen',
}

export const languages = {
  DE: 'DE',
  FR: 'FR',
  IT: 'IT',
  PL: 'PL',
  PT: 'PT',
  ES: 'ES',
  UK: 'UK',
  NL: 'NL',
}
export const availableCountriesList = {
  DE: 'DE',
  DK: 'DK',
  NL: 'NL',
  NO: 'NO',
  BE: 'BE',
  FR: 'FR',
  GR: 'GR',
  IE: 'IE',
  IT: 'IT',
  PL: 'PL',
  PT: 'PT',
  SK: 'SK',
  ES: 'ES',
  SE: 'SE',
  UK: 'UK',
}
export const availableCountriesListForVw = {
  DE: 'DE',
}
export const availableCountriesListForAudi = {
  DE: 'DE',
}
export const availableCountriesListForCariad = {
  DE: 'DE',
}
export const availableCountriesListForVwGroup = {
  DE: 'DE',
  IE: 'IE',
}
export const availableCountriesCode = {
  DE: '+49',
  DK: '+45',
  NL: '+31',
  NO: '+47',
  BE: '+32',
  FR: '+33',
  GR: '+30',
  IE: '+353',
  IT: '+39',
  PL: '+48',
  PT: '+351',
  SK: '+421',
  ES: '+34',
  SE: '+46',
  UK: '+44',
}
